"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WrapperOptions = exports.StyledSpan = exports.StyledRadioButton = exports.StyledListTitle = exports.StyledListItem = exports.StyledLink = exports.StyledItem = exports.StyledInfo = exports.StyledHeader = exports.SavePreferencesButton = exports.ListWrapper = exports.Line = exports.HeaderWrapper = exports.EmptySection = exports.ContentWrapper = exports.CloseButton = exports.ButtonWrapper = exports.AcceptAllCookiesButton = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _RadioButton = _interopRequireDefault(require("../RadioButton"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _palette = require("../../styles/palette");
var _colorUtils = require("../../utils/color-utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ContentWrapper = exports.ContentWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__ContentWrapper",
  componentId: "sc-9ek3t8-0"
})(["width:100%;"]);
var HeaderWrapper = exports.HeaderWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__HeaderWrapper",
  componentId: "sc-9ek3t8-1"
})(["display:flex;justify-content:space-between;padding:0;margin:0 0 20px 0;"]);
var StyledInfo = exports.StyledInfo = _styledComponents["default"].div.withConfig({
  displayName: "styles__StyledInfo",
  componentId: "sc-9ek3t8-2"
})(["margin-bottom:10px;font-size:14px;line-height:20px;color:", ";"], _palette.commonPalette.txBlack);
var AcceptAllCookiesButton = exports.AcceptAllCookiesButton = _styledComponents["default"].a.withConfig({
  displayName: "styles__AcceptAllCookiesButton",
  componentId: "sc-9ek3t8-3"
})(["color:", ";background:", ";padding:10px 20px;text-decoration:none;border-radius:4px;text-align:center;min-width:185px;display:inline-block;position:relative;font-size:14px;&:hover{color:", ";background:", ";}&:link{text-decoration:none;}"], _palette.commonPalette.white, function (_ref) {
  var disabled = _ref.disabled;
  return disabled ? _palette.commonPalette.lightGreen : _palette.commonPalette.sgGreen;
}, _palette.commonPalette.white, function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled ? _palette.commonPalette.lightGreen : (0, _colorUtils.darken)(_palette.commonPalette.sgGreen, 0.15);
});
var StyledListTitle = exports.StyledListTitle = _styledComponents["default"].div.withConfig({
  displayName: "styles__StyledListTitle",
  componentId: "sc-9ek3t8-4"
})(["font-size:14px;line-height:20px;color:", ";font-weight:bold;"], _palette.commonPalette.txBlack);
var StyledItem = exports.StyledItem = _styledComponents["default"].div.withConfig({
  displayName: "styles__StyledItem",
  componentId: "sc-9ek3t8-5"
})(["font-size:14px;line-height:20px;color:", ";"], _palette.commonPalette.txBlack);
var StyledLink = exports.StyledLink = _styledComponents["default"].a.withConfig({
  displayName: "styles__StyledLink",
  componentId: "sc-9ek3t8-6"
})(["color:inherit;font-weigth:600;text-decoration:underline;text-underline-offset:3px;&:hover{color:", ";text-decoration:underline;text-underline-offset:3px;}"], _palette.commonPalette.txBlack);
var StyledRadioButton = exports.StyledRadioButton = (0, _styledComponents["default"])(_RadioButton["default"]).attrs({
  height: 20
}).withConfig({
  displayName: "styles__StyledRadioButton",
  componentId: "sc-9ek3t8-7"
})(["color:", ";margin:0 14px;"], _palette.commonPalette.txBlack);
var WrapperOptions = exports.WrapperOptions = _styledComponents["default"].div.withConfig({
  displayName: "styles__WrapperOptions",
  componentId: "sc-9ek3t8-8"
})(["display:flex;"]);
var StyledHeader = exports.StyledHeader = _styledComponents["default"].div.withConfig({
  displayName: "styles__StyledHeader",
  componentId: "sc-9ek3t8-9"
})(["font-size:", ";color:", ";"], function (_ref3) {
  var isMobile = _ref3.isMobile;
  return isMobile ? '20px' : '26px';
}, _palette.commonPalette.txBlack);
var SavePreferencesButton = exports.SavePreferencesButton = _styledComponents["default"].a.withConfig({
  displayName: "styles__SavePreferencesButton",
  componentId: "sc-9ek3t8-10"
})(["color:", ";background:", ";padding:10px 20px;text-decoration:none;border-radius:4px;text-align:center;box-shaddow:rgb(0 0 0 / 12%) 0px 0px 1px,rgb(0 0 0 / 24%) 0px 1px 1px;border:1px solid ", ";min-width:185px;display:inline-block;position:relative;font-size:14px;&:hover{color:", ";background:", ";box-shaddow:rgb(0 0 0 / 12%) 0px 0px 1px,rgb(0 0 0 / 24%) 0px 1px 1px;border:1px solid ", ";}&:link{text-decoration:none;}"], _palette.commonPalette.sgGreen, function (_ref4) {
  var disabled = _ref4.disabled;
  return disabled ? _palette.commonPalette.disabledText : _palette.commonPalette.white;
}, _palette.commonPalette.borderGrey, _palette.commonPalette.sgGreen, function (_ref5) {
  var disabled = _ref5.disabled;
  return disabled ? _palette.commonPalette.disabledText : _palette.commonPalette.hoverGrey;
}, _palette.commonPalette.borderGrey);
var Line = exports.Line = _styledComponents["default"].div.withConfig({
  displayName: "styles__Line",
  componentId: "sc-9ek3t8-11"
})(["border-bottom:1px solid ", ";margin:30px 0;"], _palette.commonPalette.borderGrey);
var StyledListItem = exports.StyledListItem = _styledComponents["default"].li.withConfig({
  displayName: "styles__StyledListItem",
  componentId: "sc-9ek3t8-12"
})(["font-size:14px;line-height:20px;color:", ";margin:0 0 2px 8px;"], _palette.commonPalette.txBlack);
var EmptySection = exports.EmptySection = _styledComponents["default"].div.withConfig({
  displayName: "styles__EmptySection",
  componentId: "sc-9ek3t8-13"
})(["margin-bottom:15px;"]);
var CloseButton = exports.CloseButton = (0, _styledComponents["default"])(_Icon["default"]).attrs({
  name: 'close'
}).withConfig({
  displayName: "styles__CloseButton",
  componentId: "sc-9ek3t8-14"
})(["height:14px;color:", ";margin-top:10px;"], _palette.commonPalette.txBlack);
var ListWrapper = exports.ListWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__ListWrapper",
  componentId: "sc-9ek3t8-15"
})(["margin-top:16px;"]);
var StyledSpan = exports.StyledSpan = _styledComponents["default"].span.withConfig({
  displayName: "styles__StyledSpan",
  componentId: "sc-9ek3t8-16"
})(["margin-left:-6px;"]);
var ButtonWrapper = exports.ButtonWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__ButtonWrapper",
  componentId: "sc-9ek3t8-17"
})(["margin:20px 0;"]);
//# sourceMappingURL=styles.js.map